import { createRef } from 'react'
import { CustomRouteObject } from 'react-router-dom'

import { routeNamesPaths } from '@shared/constants'

export const ForStartupPageRoute: CustomRouteObject = {
  path: routeNamesPaths.forStartups,
  lazy: async () => {
    const { ForStartupsPage } = await import('./ui')

    return {
      Component: ForStartupsPage,
    }
  },
  nodeRef: createRef(),
}
